module.exports = __webpack_public_path__ + "img/newRentMech.79cb1ea4.svg";